import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Loader from "../components/Loader";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";

const LEVELS = [
  { level: "Level 0", topUp: "after registration", discount: "-", status: "-", trustScore: "no refund available" },
  { level: "Level 1", topUp: "after 150$", discount: "-0.10$", status: "-", trustScore: "Trust 95%, if lower - no refund available" },
  { level: "Level 2", topUp: "after 350$", discount: "-0.20$", status: "-", trustScore: "Trust 90%, if lower - no refund available" },
  { level: "Level 3", topUp: "after 700$", discount: "-0.30$", status: "-", trustScore: "Trust 85%, if lower - no refund available" },
  { level: "Level 4", topUp: "after 1,200$", discount: "-0.40$", status: "-", trustScore: "Trust 75%, if lower - no refund available" },
  { level: "Level 5", topUp: "after 2,000$", discount: "-0.50$", status: "-", trustScore: "Trust 70%, if lower - no refund available" },
  { level: "Level 6", topUp: "after 5,000$", discount: "-0.60$", status: "-", trustScore: "Trust 68%, if lower - no refund available" },
  { level: "- EXCELLENT BUYER", topUp: "after 10,000$", discount: "-1$", status: "EXCELLENT BUYER", trustScore: "Trust 68%, if lower - no refund available" },
  { level: "Level 7", topUp: "after 12,000$", discount: "-1$", status: "EXCELLENT BUYER", trustScore: "Trust 65%, if lower - no refund available" },
  { level: "- MAJOR BUYER", topUp: "after 20,000$", discount: "-1.50$", status: "MAJOR BUYER", trustScore: "Trust 65%, if lower - no refund available" },
  { level: "Level 8", topUp: "after 25,000$", discount: "-1.50$", status: "MAJOR BUYER", trustScore: "Trust 63%, if lower - no refund available" },
  { level: "Level 9", topUp: "after 35,000$", discount: "-1.50$", status: "MAJOR BUYER", trustScore: "Trust 61%, if lower - no refund available" },
  { level: "Level 10", topUp: "after 50,000$", discount: "-1.50$", status: "MAJOR BUYER", trustScore: "Trust 60%, if lower - no refund available" },
];

const TABS = [
  { key: "profile", label: "Profile" },
  { key: "profile-level", label: "Level Info" },
  { key: "edit-profile", label: "Account Settings" },
];

function formatMemberSince(isoDate) {
  if (!isoDate) return "-";
  const d = new Date(isoDate);
  const pad = n => String(n).padStart(2, "0");
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

function Profile() {
  const user = useSelector(state => state.auth.user);
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("profile");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleSaveProfile = (e) => {
    e.preventDefault();
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="page" style={{ visibility: "visible", opacity: 1 }}>
      <div className="page-main is-expanded">
        <Header onToggleSidebar={() => setMobileMenuOpen(o => !o)} />
        <Sidebar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} active="profile" />
        <div className="app-content main-content mt-0">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <div>
                  <h1 className="page-title">Profile</h1>
                </div>
                <div className="ms-auto pageheader-btn">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="#nav" onClick={e => e.preventDefault()}>Pages</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Profile</li>
                  </ol>
                </div>
              </div>

              <div className="row" id="user-profile">
                <div className="col-lg-12">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-lg-12 col-xl-6">
                          <div className="d-flex align-items-center flex-wrap">
                            <div className="avatar avatar-xxl avatar-rounded me-3"><img src="/favicon.ico" alt="Avatar" /></div>
                            <div>
                              <h4>{user?.username || "-"}</h4>
                              <p className="mb-2">Member Since: {formatMemberSince(user?.registered_at)}</p>
                              <p className="mb-2">TrustScore: 100%</p>
                              <p className="fw-semibold mb-2">
                                To next <i className="ri-settings-line align-center"></i>Level need <span className="text-info">150$</span> - <a href="/wallet" className="text-primary fs-12">Finish now</a>
                              </p>
                              <div className="progress progress-xs progress-animate">
                                <div className="progress-bar bg-primary" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style={{ width: "0%" }}></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-xl-6">
                          <div className="d-block d-sm-flex justify-content-lg-end flex-wrap mt-3 mt-lg-0">
                            <div className="d-flex align-items-center me-4">
                              <div className="avatar avatar-lg bg-primary dash2 me-2 overflow-hidden"> <i className="ri-star-line fs-20"></i> </div>
                              <div>
                                <p className="mb-1 text-muted">Total orders</p>
                                <h4 className="mb-0 fs-25">0$</h4>
                              </div>
                            </div>
                            <div className="d-flex align-items-center me-4 mt-2 mt-sm-0">
                              <div className="avatar avatar-lg bg-info dash2 me-2 overflow-hidden"> <i className="ri-money-dollar-box-line fs-20"></i> </div>
                              <div>
                                <p className="mb-1 text-muted">Total deposit</p>
                                <h4 className="mb-0 fs-25">0$</h4>
                              </div>
                            </div>
                            <div className="d-flex align-items-center me-3 mt-2 mt-sm-0">
                              <div className="avatar avatar-lg bg-warning dash2 me-2 overflow-hidden"> <i className="ri-settings-line fs-20"></i> </div>
                              <div>
                                <p className="mb-1 text-muted">Level</p>
                                <h4 className="mb-0 fs-25">0</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer pb-4 px-2">
                      <ul className="nav nav-pills omg-nav nav-style-3 d-block d-sm-flex" role="tablist">
                        {TABS.map(tab => (
                          <li className="nav-item me-0 me-sm-2" role="presentation" key={tab.key}>
                            <a
                              className={`nav-link fs-15${activeTab === tab.key ? " active" : ""}`}
                              role="tab"
                              aria-current="page"
                              href={`#${tab.key}`}
                              aria-selected={activeTab === tab.key}
                              onClick={e => { e.preventDefault(); setActiveTab(tab.key); }}
                            >
                              {tab.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="tab-content">
                    {activeTab === "profile" && (
                      <div className="tab-pane p-0 active show" role="tabpanel">
                        <div className="card custom-card">
                          <div className="card-body border-0">
                            <p className="mb-4 text-17">Profile</p>
                            <div className="row align-items-center">
                              <div className="col-lg-12 col-md-12 col-xl-3">
                                <div className="d-flex flex-wrap align-items-center">
                                  <div>
                                    <p className="text-muted mb-2">My balance: 0$</p>
                                    <p className="text-muted mb-2">Total deposit: 0$</p>
                                    <p className="text-muted mb-2">0 Total orders: 0$</p>
                                    <p className="text-muted mb-2">0 Returned orders: 0$</p>
                                    <p className="text-muted mb-2">0 Total BINs NoVBV: 0$</p>
                                    <p className="text-muted mb-2">0 Refund requested orders: 0$</p>
                                    <div style={{ border: "3px red solid", padding: 10 }}>
                                      <p className="mb-0">
                                        Limit refund: «Trust Score Ignores» seller without reputation 0 / 15 (only for Level 3 or higher)
                                      </p>
                                      <p className="mb-2 text-danger">
                                        «Trust Score Ignores» Purchase and refund for this card will be ignored by «Trust Score» system.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12 col-md-12 col-xl-9">
                                <div className="d-flex align-items-start flex-column">
                                  <div>For every <b className="text-primary">1000$</b> deposit, <b className="text-primary">25 "points"</b> will be credited to the account.</div>
                                  <div>
                                    <b className="text-primary">Refunds and Trust Score</b>:<br />
                                    If the refund fails, it means that your TrustScore is too low. Here is more detailed information about TrustScore:<br />
                                    trust_score = ((total_spent - total_refunds) / total_spent) * 100<br />
                                    so<br />
                                    total_spent - total amount of purchases;<br />
                                    total_refunds - amount of refunded cards;<br />
                                    trust_score - total trust score in percent.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "profile-level" && (
                      <div className="tab-pane p-0 active" role="tabpanel">
                        <div className="card custom-card">
                          <div className="card-body border-0">
                            <p className="mb-4 text-17">Level Info</p>
                            <div style={{ overflowX: "auto" }}>
                              <table className="table table-bordered table-hover">
                                <tbody>
                                  <tr>
                                    <th>Level</th><th>Top-up</th><th>Discount</th><th>Status</th><th>Trust score</th>
                                  </tr>
                                  {LEVELS.map((row, i) => (
                                    <tr className={i === 0 ? "table-success" : ""} key={row.level}>
                                      <th>{row.level}</th>
                                      <th>{row.topUp}</th>
                                      <th>{row.discount}</th>
                                      <th>{row.status}</th>
                                      <th>{row.trustScore}</th>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "edit-profile" && (
                      <div className="tab-pane p-0 active" role="tabpanel">
                        <div className="card custom-card">
                          <div className="card-body border-0">
                            <form className="form-horizontal" onSubmit={handleSaveProfile}>
                              <div className="row mb-4">
                                <p className="mb-4 text-17">Personal Info</p>
                                <div className="col-md-12 col-lg-12 col-xl-6">
                                  <div className="form-group">
                                    <label htmlFor="old_password" className="form-label">Current Password</label>
                                    <input type="password" className="form-control" name="old_password" id="old_password" placeholder="Current Password" value={oldPassword} onChange={e => setOldPassword(e.target.value)} />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="password" className="form-label">New Password</label>
                                    <input type="password" className="form-control" name="password" id="password" placeholder="New Password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
                                  </div>
                                </div>
                              </div>
                              <div className="row mb-4">
                                <div className="col-md-12 col-lg-12 col-xl-12">
                                  <div className="form-group">
                                    <button className="btn btn-primary" type="submit">Edit</button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="container">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-md-12 col-sm-12 text-center">
                Copyright Patrick Market © 2025 All rights reserved
              </div>
            </div>
          </div>
        </footer>
      </div>
      <style>{`
        .omg-nav .nav-link.active {
          color: #fff !important;
        }
      `}</style>
    </div>
  );
}

export default Profile;
